import { useNavigate } from 'react-router-dom';
import CustomBreadcrumbs from '../../components/common/CustomBreadcrumbs';
import OutputLeftSide from '../../components/feeOutput.js/OutputLeftSide';
import OutputRightSide from '../../components/feeOutput.js/OutputRightSide';
import { selectFeesFormData, selectFeesResponse } from '../../redux-state/selectors';
import html2pdf from 'html2pdf.js/dist/html2pdf.min.js';
import { useSelector } from 'react-redux';
import DownloadIcon from '@mui/icons-material/Download';
import SecondaryButton from '../../components/common/button/SecondaryButton';
import PrimaryButton from '../../components/common/button/PrimaryButton';
import { generateFeesReport } from '../../components/utility/generateFeesReport';

export default function FeeOutput() {
  const feesFormData = useSelector(selectFeesFormData) || {};
  const navigate = useNavigate();
  const response = useSelector(selectFeesResponse);

  const convertToPdf = () => {
    if (!response || Object.keys(response).length === 0) {
      return;
    }
    const content = generateFeesReport(feesFormData, response);

    const options = {
      filename: (response["TransactionID"] ? `${response["TransactionID"]}.pdf` : 'feesOutput.pdf'),
      margin: 0.2,
      jsPDF: {
        unit: 'in',
        format: [10, 15],
        orientation: 'portrait',
      },
    };

    html2pdf().set(options).from(content).save();
  };

  return (
    <div className='p-4 lg:p-8 min-h-[900px]'>
      <div className='flex flex-row justify-between'>
        <div className='mb-4'>
          <CustomBreadcrumbs title={"Fees"} subtitle={"Fees Output"} />
        </div>
        <div>
          <SecondaryButton
            text="Back"
            onClick={() => navigate(-1)}
          />
        </div>
      </div>

      <div className='text-3xl font-bold text-gray-900 mb-2'> Fees Output </div>
      <div className='text-gray-600 mb-6'> {response["TransactionID"]} </div>
      <div className="w-full relative mb-8">
        <div className="absolute right-0">
          <PrimaryButton
            text={<><DownloadIcon sx={{ mr: '6px' }} /> Download</>}
            onClick={convertToPdf}
          />
        </div>
      </div>

      <div className='flex flex-row w-full gap-4 lg:gap-6'>
        <div className='w-1/2'>
          <OutputLeftSide />
        </div>

        <div className="w-px bg-gray-300" />

        <div className='w-1/2 mt-3'>
          <OutputRightSide />
        </div>
      </div>
    </div>
  );
}
